import axios from "axios";
import { getAccessToken } from "./helpers";
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";

export const reportAI = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/hallucination/create`,
        data,
        { headers }
    );
}

export const generateSingleChoiceMCQ = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai//generate-multiple-questions-without-session`,
        data,
        { headers }
    );
}